import { render, staticRenderFns } from "./BatchUsersAddModal.vue?vue&type=template&id=ab2a8d50&scoped=true&"
import script from "./BatchUsersAddModal.vue?vue&type=script&lang=js&"
export * from "./BatchUsersAddModal.vue?vue&type=script&lang=js&"
import style0 from "./BatchUsersAddModal.vue?vue&type=style&index=0&id=ab2a8d50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2a8d50",
  null
  
)

export default component.exports